import { get } from 'lodash';
import pageTypes from '../../helpers/domain/pageTypes';
import * as sourceTypes from '../sourceTypes';

const pageTypesToAbbr: Record<string, 'HP' | 'SRP' | 'ADP' | 'PP'> = {
  [pageTypes.HOME_PAGE]: 'HP',
  [pageTypes.SEARCH_RESULT_PAGE]: 'SRP',
  [pageTypes.CONTENT_PAGE]: 'ADP',
  [pageTypes.PROJECT_PAGE]: 'PP',
};

export const fixCurrentPage = (currentPage: string) => {
  const sourceType = sourceTypes[pageTypesToAbbr[currentPage]];
  return get(sourceType, 'PAGE', '');
};
